import React, { useEffect } from 'react';

import { useFormDictionary } from '../../../Warehouse/Guide/Forms/FormDictionaryContext';
import {
	getEstablishmenQuery,
	getSpeciesList,
} from '../../../../helpers/establishment/backend_helper';
import { CULTIVATION_CENTER_TYPE_IDS } from '../../../Warehouse/Guide/constants/guideConstants';

/**
 * Carga especies y centros de cultivo en FormDictionaryContext para IntakeForm
 * (misma fuente que OrigenSection del generador de guías).
 */
const IntakeFormDictionaryBootstrap = () => {
	const { setSpecies, setCultivationCenters } = useFormDictionary();

	useEffect(() => {
		let cancelled = false;
		const load = async () => {
			try {
				const speciesResponse = await getSpeciesList();
				if (cancelled) return;
				setSpecies(
					Array.isArray(speciesResponse)
						? speciesResponse
						: speciesResponse?.data || []
				);

				const centersResponse = await getEstablishmenQuery({
					fields: ['_id', 'name', 'code_siep'],
					sort: ['name:asc'],
					filters: {
						disable: { $eq: false },
						establishment_type_id: { $in: CULTIVATION_CENTER_TYPE_IDS },
					},
					pagination: { page: 1, pageSize: 1000 },
				});
				if (cancelled) return;
				setCultivationCenters(centersResponse?.data || []);
			} catch (e) {
				if (!cancelled) {
					console.error('[IntakeFormDictionaryBootstrap]', e);
				}
			}
		};
		load();
		return () => {
			cancelled = true;
		};
	}, [setSpecies, setCultivationCenters]);

	return null;
};

export default IntakeFormDictionaryBootstrap;
